<template>
  <div class="invite-page">
    <div class="invite-bg" :style="bgStyle"></div>

    <div class="invite-topbar">
      <div class="invite-back" @click="onBack">
        <img class="invite-back__img" :src="backIconUrl" alt="back" />
      </div>
      <div class="invite-title">Invite friends to get coins</div>
      <div class="invite-topbar__right"></div>
    </div>

    <div class="invite-body">
      <div class="invite-panel" :style="panelStyle">
        <div v-if="loading" class="invite-tip">Loading...</div>
        <div v-else-if="errorText" class="invite-tip invite-tip--error">{{ errorText }}</div>
        <div class="invite-inviter">
          <div class="invite-avatar">
            <img v-if="landing.inviterAvatar" class="invite-avatar__img" :src="landing.inviterAvatar" alt="avatar" />
            <div v-else class="invite-avatar__placeholder"></div>
          </div>
          <div class="invite-inviter__info">
            <div class="invite-inviter__name">{{ landing.inviterNickname || '-' }}</div>
            <div class="invite-inviter__id">ID:{{ landing.inviterUserNumber || '-' }}</div>
          </div>
        </div>

        <div class="invite-msg">A gift for you, come and play with me!</div>

        <div class="invite-rewards">
          <div v-for="(r, idx) in rewards" :key="idx" class="invite-reward">
            <div class="invite-reward__imgwrap">
              <img class="invite-reward__img" :src="rewardIcon(r)" alt="reward" />
            </div>
            <div class="invite-reward__label">{{ rewardLabel(r) }}</div>
          </div>
        </div>

        <div class="invite-join" @click="onJoin">
          <img class="invite-join__img" :src="joinBtnUrl" alt="Join the party" />
          <div class="invite-join__text">Join the party</div>
        </div>

        <div v-if="landing.roomId" class="invite-room">Invite code: {{ landing.inviterUserNumber || '-' }}</div>
      </div>
    </div>

    <div class="invite-bottom">
      <div class="invite-app">
        <img class="invite-app__icon" :src="appIconUrl" alt="icon" />
        <div class="invite-app__text">
          <div class="invite-app__name">{{ appName }}</div>
          <div class="invite-app__desc">Meet new friends</div>
        </div>
      </div>
      <div class="invite-download" @click="onDownload">
        <img class="invite-download__img" :src="downloadBtnUrl" alt="Download" />
        <div class="invite-download__text">Download</div>
      </div>
    </div>
  </div>
</template>

<script>
const OSS_BASE_URL = "https://komi-pord.oss-eu-central-1.aliyuncs.com/vue/"

export default {
  name: 'InviteLandingIndex',
  data() {
    return {
      appName: 'Komiya',
      backIconUrl: OSS_BASE_URL + "invite/back.png",
      bgUrl: OSS_BASE_URL + "invite/backgroud.png",
      panelUrl: OSS_BASE_URL + "invite/panel.png",
      joinBtnUrl: OSS_BASE_URL + "invite/joinparty.png",
      appIconUrl: OSS_BASE_URL + "invite/icon.png",
      downloadBtnUrl: OSS_BASE_URL + "invite/download.png",
      coinFallbackUrl: OSS_BASE_URL + "invite/coins.png",
      landing: {
        inviterAvatar: '',
        inviterNickname: '',
        inviterUserNumber: null,
        roomId: null,
        registerPackageRewards: []
      },
      loading: false,
      errorText: '',
      query: {}
    }
  },
  computed: {
    bgStyle() {
      return { backgroundImage: `url(${this.bgUrl})` }
    },
    panelStyle() {
      return { backgroundImage: `url(${this.panelUrl})` }
    },
    rewards() {
      const list = (this.landing && this.landing.registerPackageRewards) || []
      return list.slice(0, 2)
    }
  },
  created() {
    this.query = (this.$route && this.$route.query) || {}
    this.fetchLanding()
  },
  methods: {
    async fetchLanding() {
      const inviteCode = this.query.invite_code
      if (!inviteCode) {
        return
      }
      this.loading = true
      this.errorText = ''

      const origin = ((process.env.VUE_APP_API_ORIGIN || process.env.VUE_APP_PROXY_TARGET || '') + '').trim()
      const url = `${origin}/api/chat/invite/landing?invite_code=${encodeURIComponent(inviteCode)}`
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
      const timer = setTimeout(() => {
        if (controller) {
          controller.abort()
        }
      }, 8000)
      try {
        const resp = await fetch(url, { method: 'GET', signal: controller ? controller.signal : undefined })
        if (!resp.ok) {
          throw new Error(`http_${resp.status}`)
        }
        const json = await resp.json()
        if (json && json.code && json.code !== '0000') {
          throw new Error(json.message || 'api_error')
        }
        const data = json && (json.result || json.data || json)
        if (data && typeof data === 'object') {
          this.landing = Object.assign({}, this.landing, data || {})
        }
      } catch (e) {
        if (e && e.name === 'AbortError') {
          this.errorText = '请求超时'
        } else {
          this.errorText = (e && e.message) ? `请求失败(${e.message})` : '请求失败'
        }
      } finally {
        clearTimeout(timer)
        this.loading = false
      }
    },
    rewardIcon(r) {
      if (r && r.icon) {
        return r.icon
      }
      return this.coinFallbackUrl
    },
    rewardLabel(r) {
      if (!r) {
        return '-'
      }
      if (r.rewardType === 1) {
        return `${r.amount || 0} Diamonds`
      }
      if (r.rewardType === 2) {
        const days = r.amount && r.amount > 0 ? `${r.amount}days` : 'Permanent'
        return `Avatar frame ${days}`
      }
      return `${r.amount || 0}`
    },
    onBack() {
      if (window.history.length > 1) {
        window.history.back()
        return
      }
      this.$router.replace('/invite')
    },
    onJoin() {
      const url = this.query.join_url || this.query.download_url || this.query.url
      if (url) {
        window.location.href = url
      }
    },
    onDownload() {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.komi.chatroom'
    }
  }
}
</script>

<style scoped>
.invite-page {
  min-height: 100vh;
  background: #0b0b0b;
  position: relative;
  overflow: hidden;
}

.invite-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.02);
}

.invite-topbar {
  position: relative;
  z-index: 2;
  height: calc(2.75rem + env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}

.invite-back {
  width: 4rem;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invite-back__img {
  width: 2.75rem;
  height: 2.75rem;
  display: block;
}

.invite-title {
  flex: 1;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
}

.invite-topbar__right {
  width: 4rem;
  height: 2.75rem;
}

.invite-body {
  position: relative;
  z-index: 2;
  min-height: calc(100vh - 2.75rem - env(safe-area-inset-top) - 6rem - env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
}

.invite-panel {
  width: min(22.5rem, 92vw);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 1.125rem 1.125rem 1.25rem;
  box-sizing: border-box;
  position: relative;
}

.invite-tip {
  position: absolute;
  left: 1.125rem;
  right: 1.125rem;
  top: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.28);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.75rem;
  text-align: center;
}

.invite-tip--error {
  background: rgba(160, 20, 20, 0.35);
}

.invite-inviter {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.invite-avatar {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.15);
  flex: 0 0 auto;
}

.invite-avatar__img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.invite-avatar__placeholder {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.12);
}

.invite-inviter__info {
  color: #fff;
  min-width: 0;
}

.invite-inviter__name {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invite-inviter__id {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  opacity: 0.9;
}

.invite-msg {
  margin-top: 0.875rem;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1rem;
  line-height: 1.25;
  font-weight: 600;
}

.invite-rewards {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.invite-reward__imgwrap {
  width: 100%;
  padding-top: 74%;
  position: relative;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 0.5rem;
}

.invite-reward__img {
  position: absolute;
  inset: 0.5rem;
  width: calc(100% - 1rem);
  height: calc(100% - 1rem);
  object-fit: contain;
  display: block;
}

.invite-reward__label {
  margin-top: 0.5rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.75rem;
}

.invite-join {
  margin-top: 1.125rem;
  position: relative;
  width: 100%;
  height: 3.25rem;
  cursor: pointer;
}

.invite-join__img {
  width: 100%;
  height: 100%;
  display: block;
}

.invite-join__text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.82);
}

.invite-room {
  margin-top: 0.75rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.8125rem;
}

.invite-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  height: calc(6rem + env(safe-area-inset-bottom));
  padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.invite-app {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.invite-app__icon {
  width: 3.375rem;
  height: 3.375rem;
  border-radius: 0.625rem;
  display: block;
  background: rgba(255, 255, 255, 0.08);
}

.invite-app__text {
  color: #fff;
}

.invite-app__name {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.1;
}

.invite-app__desc {
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  opacity: 0.85;
}

.invite-download {
  position: relative;
  width: 8.25rem;
  height: 3.25rem;
  flex: 0 0 auto;
  cursor: pointer;
}

.invite-download__img {
  width: 100%;
  height: 100%;
  display: block;
}

.invite-download__text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.82);
}
</style>
